export const TimelineItem: React.FC<{
  label: string;
  sub: string;
  state: "done" | "active" | "pending";
  last?: boolean;
}> = ({ label, sub, state, last }) => {
  const dotBg = {
    done: "bg-emerald-100/20 border-emerald-200",
    active: "bg-amber-100/20 border-amber-200",
    pending: "bg-gray-100/20 border-gray-200",
  }[state];

  return (
    <div className="flex gap-2.5 relative pb-4 last:pb-0">
      {!last && (
        <div className="absolute left-[13px] top-7 bottom-0 w-px bg-gray-100/20" />
      )}
      <div
        className={`w-7 h-7 rounded-full border flex items-center justify-center flex-shrink-0 z-10 ${dotBg}`}
      >
        {state === "done" && (
          <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
            <path
              d="M3 8l3.5 3.5L13 5"
              stroke="#10b981"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        {state === "active" && (
          <div className="w-2 h-2 rounded-full bg-amber-500/50" />
        )}
        {state === "pending" && (
          <div className="w-2 h-2 rounded-full bg-gray-200/20" />
        )}
      </div>
      <div className="pt-1">
        <p
          className={`text-[13px] font-medium mb-0.5 ${
            state === "pending" ? "text-gray-400" : "text-gray-800"
          }`}
        >
          {label}
        </p>
        <p className="text-[11px] text-gray-400">{sub}</p>
      </div>
    </div>
  );
};
